import type { LayoutSection, PageComponent } from '../types/mate.dto.js';

export interface CompileOptions {
    enableVisitTrack?: boolean;
    customHeader?: string;
    enableGoogleAnalytics?: boolean;
    googleAnalyticsMeasurementId?: string;
}

export class LayoutCompiler {
    // Build HTML head template — add/remove framework includes here
    private static buildHtmlHead(options?: CompileOptions): string {
        const visitTrackSnippet = options?.enableVisitTrack
            ? `\n\n        if (mateSdk.engagementService) {\n            mateSdk.engagementService.trackVisit();\n        }`
            : '';
        const gtagSnippet = (options?.enableGoogleAnalytics && options?.googleAnalyticsMeasurementId)
            ? `\n    <!-- Google tag (gtag.js) -->\n    <script async src="https://www.googletagmanager.com/gtag/js?id=${options.googleAnalyticsMeasurementId}"></script>\n    <script>\n      window.dataLayer = window.dataLayer || [];\n      function gtag(){dataLayer.push(arguments);}\n      gtag('js', new Date());\n      gtag('config', '${options.googleAnalyticsMeasurementId}');\n    </script>`
            : '';
        console.log('gtagSnippet', gtagSnippet);
        return `${gtagSnippet}
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <!-- Tailwind CSS -->
    <script src="https://cdn.tailwindcss.com"></script>
    <!-- Alpine.js -->
    <script defer src="https://cdn.jsdelivr.net/npm/alpinejs@3.x.x/dist/cdn.min.js"></script>
    <!-- Google Fonts -->
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet">
    <meta name="record-id" content="{{id}}">
    <script type="module">
        import * as mateSdk from '/static/index.js';
        window.mateSdk = mateSdk;${visitTrackSnippet}
        window.dispatchEvent(new CustomEvent('mateSdkReady'));
    </script>

    <script async src="https://cdn.jsdelivr.net/npm/marked@12.0.2/marked.min.js" onload="renderAllMarkdown()"></script>
    <script>
        function renderAllMarkdown() {
            console.log('renderAllMarkdown');
            document.querySelectorAll('.markdown-content').forEach(container => {
                const rawText = container.textContent.trim();
                console.log(rawText);


                container.innerHTML = marked.parse(rawText);
            });
        }
    </script>
    <style>
        body { font-family: 'Inter', sans-serif; }
    </style>`;
    }

    /**
     * Compile layout + components into a full HTML document.
     */
    static compile(lsections: LayoutSection[], components: PageComponent[], title?: string, options?: CompileOptions): string {
        const body = this.compileBody(lsections, components);
        const customHeader = options?.customHeader?.trim() ? `\n    ${options.customHeader}` : '';
        return `<!DOCTYPE html>
<html lang="en">
<head>
    ${this.buildHtmlHead(options)}
    <title>${title || 'Page'}</title>${customHeader}
</head>
<body>
${body}
</body>
</html>`;
    }

    /**
     * Compile layout + components into just the body grid HTML (no wrapper).
     */
    static compileBody(lsections: LayoutSection[], components: PageComponent[]): string {
        let compiledHtml = '';

        for (const section of lsections) {
            // Setup a generic Tailwind Grid wrapper
            compiledHtml += '\n<div class="grid grid-cols-12 gap-6 w-full max-w-7xl mx-auto px-4">';

            // Render columns
            for (const col of section.columns) {
                compiledHtml += '\n    <div class="col-span-12 md:col-span-' + col.span + '">';
                for (const id of col.ids) {
                    const compHtml = components.find(c => c.id === id)?.html || '';
                    compiledHtml += '\n        <div data-component-id="' + id + '">' + compHtml + '</div>';
                }
                compiledHtml += '\n    </div>';
            }

            compiledHtml += '\n</div>';
        }

        return compiledHtml;
    }
}
